import React, { useState, useEffect } from 'react';
import { Container, Card, Alert, Spinner, Badge } from 'react-bootstrap';
import { FaShieldAlt, FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';
import api from '../services/api';

const TermsAndConditions = () => {
    const [terms, setTerms] = useState([]);
    const [loading, setLoading] = useState(true);

    // --- DỮ LIỆU ĐIỀU KHOẢN MẪU CẬP NHẬT THEO MÔ HÌNH 8:2 ---
    const fallbackTerms = [
        {
            _id: "1",
            title: "Mô hình vận hành Bot Cha - Bot Con",
            content: "NeXBot cung cấp giải pháp giao dịch thông qua tín hiệu từ Bot Cha gửi đến Bot Con cài đặt tại thiết bị của khách hàng.\nNeXBot trực tiếp vận hành Bot Cha, có quyền đóng/mở hoặc thay thế Bot để đảm bảo an toàn hệ thống.\nKhách hàng chịu trách nhiệm duy trì nguồn điện, internet và cài đặt đúng thông số (API, Magic Number) được cung cấp."
        },
        {
            _id: "2",
            title: "Phân chia lợi nhuận & Thanh toán",
            content: "Dịch vụ áp dụng mô hình chia sẻ lợi nhuận 8:2 (Khách hàng hưởng 80%, NeXBot hưởng 20% lợi nhuận ròng).\nThông báo lợi nhuận sẽ được gửi qua email hàng tuần.\nKhách hàng có trách nhiệm thanh toán phí dịch vụ vào Thứ 7 và Chủ nhật hàng tuần. Dịch vụ sẽ tạm dừng nếu việc thanh toán bị chậm trễ."
        },
        {
            _id: "3",
            title: "Quản trị vốn và Rủi ro",
            content: "Mức rủi ro tối đa được khống chế ở mức 20% tổng tài khoản (với điều kiện khách hàng tuân thủ đúng mức vốn tối thiểu).\nKhách hàng không được rút bớt vốn dẫn đến thiếu hụt so với mức đăng ký ban đầu.\nNeXBot miễn trừ trách nhiệm nếu lỗi phát sinh từ phía khách hàng (mất kết nối, cài đặt sai loại tài khoản, tự ý can thiệp lệnh)."
        }
    ];

    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const res = await api.get('/public/terms');
                let data = [];
                // Kiểm tra các cấu trúc dữ liệu trả về khác nhau từ Backend
                if (Array.isArray(res.data)) {
                    data = res.data;
                } else if (res.data?.terms) {
                    data = res.data.terms;
                } else if (res.data?.data) {
                    data = res.data.data;
                }

                setTerms(data.length > 0 ? data : fallbackTerms);
            } catch (err) {
                console.error("Lỗi tải điều khoản:", err);
                setTerms(fallbackTerms); 
            } finally {
                setLoading(false);
            }
        };
        fetchTerms();
    }, []);

    if (loading) return (
        <div className="d-flex flex-column justify-content-center align-items-center" style={{minHeight: '80vh'}}>
            <Spinner animation="grow" variant="warning" />
            <p className="text-warning mt-3 fw-bold" style={{letterSpacing: '2px'}}>ĐANG TẢI DỮ LIỆU PHÁP LÝ...</p>
        </div>
    );

    return (
        <Container className="py-5 animate__animated animate__fadeIn">
            <Card className="border-0 shadow-lg" style={{ borderRadius: '24px', overflow: 'hidden', background: '#fff' }}>
                
                {/* Header Profile - Dark Gold Theme */}
                <div className="p-5 text-center" style={{ 
                    background: 'linear-gradient(135deg, #020617 0%, #0f172a 100%)', 
                    borderBottom: '4px solid #f59e0b' 
                }}>
                    <Badge bg="warning" text="dark" className="mb-3 px-3 py-2 rounded-pill text-uppercase fw-bold" style={{fontSize: '0.7rem'}}>
                        <FaShieldAlt className="me-1"/> Hợp đồng điện tử
                    </Badge>
                    <h2 className="text-white fw-bold mb-0 text-uppercase" style={{ letterSpacing: '1px', fontSize: '1.8rem' }}>
                        <span style={{color: '#f59e0b'}}>📜 Điều khoản</span> Dịch vụ NeXBot
                    </h2>
                    <p className="text-white-50 small mt-3 mx-auto" style={{maxWidth: '500px'}}>
                        Mô hình vận hành 8:2 - Đảm bảo tính minh bạch và an toàn tài khoản
                    </p>
                </div>

                <Card.Body className="p-4 p-md-5">
                    {/* Thông báo vận hành quan trọng */}
                    <Alert variant="warning" className="border-0 shadow-sm mb-5 d-flex align-items-center p-3" style={{borderRadius: '15px', background: 'rgba(245, 158, 11, 0.1)', color: '#92400e'}}>
                        <FaExclamationTriangle className="me-3 fs-4 flex-shrink-0"/> 
                        <div className="small">
                            <strong>LƯU Ý QUAN TRỌNG:</strong> NeXBot trực tiếp vận hành Bot Cha. Mọi hành vi rút vốn gây thiếu hụt so với mức đăng ký hoặc can thiệp lệnh tay sẽ dẫn đến việc từ chối bảo hiểm rủi ro.
                        </div>
                    </Alert>

                    {/* Danh sách điều khoản */}
                    {terms.map((item, index) => (
                        <div key={item._id || index} className="mb-5">
                            <h5 className="fw-bold text-dark mb-3 d-flex align-items-start">
                                <span className="bg-warning text-dark d-inline-flex align-items-center justify-content-center me-3 mt-1 shadow-sm" 
                                      style={{ width: '32px', height: '32px', fontSize: '0.9rem', flexShrink: 0, fontWeight: '800', borderRadius: '8px' }}>
                                    {index + 1}
                                </span>
                                <span style={{fontSize: '1.2rem', color: '#1e293b'}}>{item.title}</span>
                            </h5>
                            
                            <div 
                                className="ps-5 ms-2 border-start border-2 border-light"
                                style={{ 
                                    whiteSpace: 'pre-line', // Tự động xuống dòng theo ký tự \n
                                    fontSize: '1.05rem', 
                                    lineHeight: '1.8', 
                                    color: '#475569',
                                    textAlign: 'justify'
                                }}
                            >
                                {item.content}
                            </div>
                        </div>
                    ))}

                    {/* Footer Xác nhận */}
                    <div className="mt-5 p-4 rounded-4 shadow-sm" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                        <h6 className="fw-bold text-dark d-flex align-items-center mb-3">
                            <FaCheckCircle className="me-2 text-success"/> CAM KẾT SỬ DỤNG DỊCH VỤ:
                        </h6>
                        <p className="small text-secondary mb-0" style={{lineHeight: '1.6'}}>
                            Bằng việc cài đặt phần mềm NeXBot (Bot Con), khách hàng xác nhận đã hiểu rõ cơ chế vận hành tập trung. Khách hàng cam kết tuân thủ nghĩa vụ thanh toán phí dịch vụ 20% trên lợi nhuận ròng vào cuối tuần để duy trì kết nối hệ thống.
                        </p>
                    </div>
                </Card.Body>
                
                {/* Copyright & Version */}
                <div className="bg-light p-3 text-center border-top">
                    <small className="text-muted font-monospace" style={{fontSize: '11px'}}>
                        NEXBOT ECOSYSTEM • 8:2 PROFIT SHARING MODEL • VER 2.1 • {new Date().getFullYear()}
                    </small>
                </div>
            </Card>

            {/* CSS bổ sung để giao diện mượt hơn */}
            <style>{`
                .animate__fadeIn { animation: fadeIn 0.8s; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </Container>
    );
};

export default TermsAndConditions;